import { useActionState, useEffect, useState } from "react";
import Input from "../../../../components/input";
import IconButton from "../../../../components/icon-button";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { CharityEventType } from "../../../../models";
import { State, updateCharityEventType } from "../actions";
import FormError from "../../../../components/form-error";
import toast from "react-hot-toast";

export default function CharityEventTypeUpdateRow({
  item,
  onCancel,
  onChanged,
}: {
  item: CharityEventType;
  onCancel: () => void;
  onChanged: () => void;
}) {
  const [name, setName] = useState(item.name || "");

  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: item.name || "",
    },
  };

  const updateWithId = updateCharityEventType.bind(null, item.id!);
  const [state, formAction, isPending] = useActionState(updateWithId, initialState);

  useEffect(() => {
    if (!state.success) return;

    toast.success("Charity event type updated successfully");
    onChanged();
    onCancel();
  }, [state, onChanged, onCancel]);

  return (
    <>
      <td colSpan={2} className="px-6 py-4 bg-gray-100">
        <form action={formAction} className="flex gap-2 items-end">
          <div className="flex-1">
            <Input
              id="name"
              name="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter name"
              required
            />
          </div>
          <IconButton label="Update" icon={CheckIcon} loading={isPending} />
          <IconButton type="button" label="Cancel" icon={XMarkIcon} onClick={onCancel} />
        </form>
        <FormError id="name-error" message={state.errors?.name} />
      </td>
    </>
  );
}
